module.exports = __webpack_public_path__ + "static/Corporates-d873a695fb8ecb0ce1a30a7e60e04c5a.jpg";